table{width:100%}
/*# sourceMappingURL=show-table.component-GHMRZK5T.css.map */
